const ShowPopUp = (showPopUp) => {
  return {
    type: "SHOW_POPUP",
    showPopUp
  }
}

export default ShowPopUp
